import { SVGProps } from 'react';
import cn from 'classnames';
import sprite from '@packages/shared/assets/sprites/sprite.svg';
import { IconNames, GradientNames } from '@packages/shared/svg-sprites/entities';
import { AnyString } from '@packages/shared/core/common/entities';
import styles from './Icon.module.scss';

type IconProps = {
  name: IconNames;
  title?: string;
  className?: string;
  fill?: `url(#${GradientNames})` | AnyString;
  fullSize?: boolean;
} & Omit<SVGProps<SVGSVGElement>, 'name' | 'fill'>;

export const Icon = ({ name, title, className = '', fullSize = false, ...rest }: IconProps) => {
  const role = title ? 'img' : undefined;
  const ariaAttribute = !title ? { 'aria-hidden': true } : { 'aria-label': title };

  return (
    <svg
      {...rest}
      width={fullSize ? undefined : '16px'}
      height={fullSize ? undefined : '16px'}
      role={role}
      className={cn(styles.root, className, { [styles.fullSize]: fullSize })}
      {...ariaAttribute}
    >
      <use xlinkHref={`${sprite}#${name}`} />
    </svg>
  );
};

export default Icon;
